module.exports = __webpack_public_path__ + "static/media/batch.b78e1f87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/batch.png
// module id = 105
// module chunks = 0